import Dashboard from "pages/Dashboard/Dashboard"
import Login from "pages/Login"
import User from "pages/User/User"
import UserForm from "pages/User/UserForm"
import Setting from "pages/Setting/Setting"
import Brand from "pages/Brand/Brand"
import BrandForm from "pages/Brand/BrandForm"
import Product from "pages/Product/Product"
import ProductForm from "pages/Product/ProductForm"
import SalesStock from "pages/SalesStock/SalesStock"
import SalesStockForm from "pages/SalesStock/SalesStockForm"
import RentalStock from "pages/RentalStock/RentalStock"
import RentalStockForm from "pages/RentalStock/RentalStockForm"
import Category from "pages/Category/Category"
import CategoryForm from "pages/Category/CategoryForm"
import Customer from "pages/Customer/Customer"
import CustomerForm from "pages/Customer/CustomerForm"
import Transaction from "pages/Transaction/Transaction"
import SalesOrder from "pages/Transaction/SalesOrder"
import RentalOrder from "pages/Transaction/RentalOrder"
import TransactionDetail from "pages/Transaction/TransactionDetail"
import Tax from "pages/Setting/Tax/Tax"

export const routes = [
   {
      path: "/login",
      element: <Login />
   },
   {
      path: "/",
      element: <Dashboard />
   },

   {
      path: "/transaction",
      element: <Transaction />
   },   
   {
      path: "/transaction-detail",
      element: <TransactionDetail />
   },
   
   {
      path: "/sales-order",
      element: <SalesOrder />
   },
   {
      path: "/rental-order",
      element: <RentalOrder />
   },

   {
      path: "/brand",
      element: <Brand />
   },
   {
      path: "/brand/form",
      element: <BrandForm />
   },
   {
      path: "/category",
      element: <Category />
   },
   {
      path: "/category/form",
      element: <CategoryForm />
   },
   {
      path: "/customer",
      element: <Customer />
   },
   {
      path: "/customer/form",
      element: <CustomerForm />
   },
   {
      path: "/product",
      element: <Product />
   },
   {
      path: "/product/form",
      element: <ProductForm />
   },
   {
      path: "/sales-stock",
      element: <SalesStock />
   },
   {
      path: "/sales-stock/form",
      element: <SalesStockForm />
   },
   {
      path: "/rental-stock",
      element: <RentalStock />
   },
   {
      path: "/rental-stock/form",
      element: <RentalStockForm />
   },

   {
      path: "/setting",
      element: <Setting />
   },
   {
      path: "/setting/user",
      element: <User />
   },
   {
      path: "/setting/user/form",
      element: <UserForm />
   },
   {
      path: "/setting/tax",
      element: <Tax />
   },
]

export const ROLE_ADMIN = "admin"
export const ROLE_OWNER = "owner"